import { createApp } from '@app/adapters/create-app'

import PDFTron from '../sections/pdftron'
import DocumentPreviewViewer from '../sections/document-preview-viewer.vue'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='pdftron-document-viewer']").each(function () {
    const data = this.dataset

    // `data-document-id` (full-page viewer) mounts the wrapper;
    // `data-document-urls` (multi-doc / AI-proposal flows) mounts PDFTron directly.
    if (data.documentId) {
      createApp(DocumentPreviewViewer, {
        documentId: Number(data.documentId),
        documentUrl: data.documentUrl,
        initialPdftronPath: data.pdftronPath,
        enableAnnotations: data.enableAnnotations === 'true',
        enableAnnotationsToolbar: data.enableAnnotationsToolbar === 'true',
        class: data.class,
      }).mount(this)
    } else {
      createApp(PDFTron, {
        path: data.path,
        initialDocs: JSON.parse(data.documentUrls),
        ownerId: data.ownerId,
        ownerType: data.ownerType,
        enableAnnotations: data.enableAnnotations === 'true',
        enableAnnotationsToolbar: data.enableAnnotationsToolbar === 'true',
        class: data.class,
        disableMouseWheelZoom: data.disableMouseWheelZoom === 'true',
        enableAiProposalDrawer: data.enableAiProposalDrawer === 'true',
        hideTabButtons: data.hideTabButtons === 'true',
      }).mount(this)
    }
  })
})
